export default __webpack_public_path__ + "static/media/image-polaroid.8c1db948.svg";